/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';

import {AngularModalService} from '../common/modal/angular-modal.service';
import {CreativeCopyModalComponent, CreativeCopyModalResult} from './creative-copy-modal.component';

export interface CreativeCopyModalOptions {
  model: any;
  specifiedAdvertiser?: any;
  onComplete?: (result: CreativeCopyModalResult) => void;
}

@Injectable({providedIn: 'root'})
export class CreativeCopyModalService {
  constructor(private readonly angularModalService: AngularModalService) {
  }

  open(options: CreativeCopyModalOptions): void {
    this.angularModalService.show(CreativeCopyModalComponent, {
      initialState: options
    });
  }
}
